<template>
  <div class="notifications-wrap">
    <div
      v-for="(notifcation, key) in notifications"
      :key="key"
      class="notification notification-animation"
      :class="`notification--${notifcation.type}`"
      @mouseover="removeTimeout(key)"
      @mouseout="addTimeout(key)"
    >
      <span class="notification__text" v-html="notifcation.message"></span>
      <button class="butn notification__close" @click="removeNotification(key)">
        <i class="iconmoon-exit"></i>
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from "../../eventBus";

export default {
  data() {
    return {
      notifications: {},
      timeouts: {},
      time: 5000,
      defaultId: 9999
    };
  },
  created() {
    EventBus.$on("AddNewNotification", (message, type) => {
      this.addNotification(message, type);
    });
  },
  mounted() {
    this.addNotificationsOnInit();
  },
  methods: {
    removeNotification(id) {
      this.$delete(this.notifications, id);
      this.$delete(this.timeouts, id);
    },
    removeTimeout(id) {
      clearTimeout(this.timeouts[id]);
      this.$delete(this.timeouts, id);
    },
    addTimeout(id) {
      let timeout = setTimeout(() => {
        this.removeNotification(id);
      }, this.time);
      this.$set(this.timeouts, id, timeout);
    },
    addNotification(message, type) {
      const newId = this.generateId();
      const newObj = { message, type };
      this.$set(this.notifications, newId, newObj);
      this.addTimeout(newId);
    },
    generateId() {
      return this.defaultId--;
    },
    addNotificationsOnInit() {
      if (Object.keys(this.notifications).length > 0) {
        for (let prop in this.notifications) {
          this.addTimeout(prop);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notifications-wrap {
  position: fixed;
  z-index: 999;
  bottom: 20px;
  right: 25px;
}

.notification {
  position: relative;
  font-size: 1rem;
  padding: 1em 2em 1em 1em;
  margin-bottom: 1em;
  max-width: 16em;
  border-radius: 0.25em;
}

.notification--success {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;

  i {
    color: darken(#3c763d, 10%);
  }
}

.notification--error {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;

  i {
    fill: darken(#a94442, 10%);
  }
}

.notification--info {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;

  i {
    color: darken(#8a6d3b, 10%);
  }
}

.notification__close {
  position: absolute;
  right: 0.5em;
  top: 50%;
  transform: translateY(-50%);
  line-height: 0;

  i {
    font-size: 0.8em;
  }
}

.notification__text {
  strong {
    font-weight: 600;
  }

  a {
    color: currentColor;
    font-weight: 600;
    text-decoration: underline;

    & :hover {
      text-decoration: none;
    }
  }
}

.notification-animation {
  animation: animation 1500ms linear both;
}

@keyframes animation {
  0% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 250, 0, 0, 1);
  }
  3.14% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 160.737, 0, 0, 1);
  }
  4.3% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 132.565, 0, 0, 1);
  }
  6.27% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 91.357, 0, 0, 1);
  }
  8.61% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 51.939, 0, 0, 1);
  }
  9.41% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 40.599, 0, 0, 1);
  }
  12.48% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 6.498, 0, 0, 1);
  }
  12.91% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 2.807, 0, 0, 1);
  }
  16.22% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -17.027, 0, 0, 1);
  }
  17.22% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -20.404, 0, 0, 1);
  }
  19.95% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -24.473, 0, 0, 1);
  }
  23.69% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -21.178, 0, 0, 1);
  }
  27.36% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -13.259, 0, 0, 1);
  }
  28.33% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -11.027, 0, 0, 1);
  }
  34.77% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.142, 0, 0, 1);
  }
  39.44% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 2.725, 0, 0, 1);
  }
  42.18% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 2.675, 0, 0, 1);
  }
  56.99% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.202, 0, 0, 1);
  }
  61.66% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.223, 0, 0, 1);
  }
  66.67% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.104, 0, 0, 1);
  }
  83.98% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0.01, 0, 0, 1);
  }
  100% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
}
</style>
